/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * How to apply a `session` content edit when the referenced session is a shared TEMPLATE. Omitted, the edit is refused with 428 Precondition Required (PROGRAM.UPDATE_REQUIRES_CONFIRMATION): a template is never mutated from inside a therapy. `clone` confirms forking a private copy owned by this therapy — the template and every other therapy stay untouched, and the change reaches only this program’s future assignments. Ignored when the referenced session is already a one-off (it is edited in place) or when no `session` edit is sent.
 * @export
 * @enum {string}
 */
export enum EnProgramSessionUpdateStrategy {
    Clone = 'clone'
}

